import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const { userProfile, updateUserProfile, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    displayName: userProfile?.displayName || '',
    email: userProfile?.email || '',
    password: '',
    confirmPassword: ''
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (formData.password && formData.password !== formData.confirmPassword) {
      return setError('Passwords do not match');
    }

    if (formData.password && formData.password.length < 6) {
      return setError('Password must be at least 6 characters');
    }

    try {
      setError('');
      setMessage('');
      setLoading(true);

      const updates = {
        displayName: formData.displayName,
        email: formData.email
      };

      if (formData.password) {
        updates.password = formData.password;
      }

      await updateUserProfile(updates);
      setMessage('Profile updated successfully');
      setFormData(prev => ({ ...prev, password: '', confirmPassword: '' }));
    } catch (error) {
      setError('Failed to update profile: ' + error.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      setError('Failed to log out');
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Profile</h2>
        {error && <div className="alert alert-error">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="profile-display-name">Display name</label>
            <input
              id="profile-display-name"
              type="text"
              name="displayName"
              value={formData.displayName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="profile-email">Email</label>
            <input
              id="profile-email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="profile-new-password-leave-blank-to-ke">New password (leave blank to keep your current one)</label>
            <input
              id="profile-new-password-leave-blank-to-ke"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>
          {formData.password && (
            <div className="form-group">
              <label htmlFor="profile-confirm-new-password">Confirm new password</label>
              <input
                id="profile-confirm-new-password"
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
            </div>
          )}
          <button disabled={loading} type="submit" className="btn btn-primary">
            Save changes
          </button>
        </form>
        <button onClick={handleLogout} className="btn btn-secondary mt-3">
          Log out
        </button>
      </div>
    </div>
  );
} 